/**
 */
export default () => {
    const priceDom = document.querySelector('meta[name="price.properties"]');
    const priceProperties = priceDom?.getAttribute('content');
    return (priceProperties && JSON.parse(priceProperties)) || {};
}

